import React from 'react'
import Slider from 'react-slick';

const Processtwo = () => {
    const Processslider = {
        speed: 800,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        variableWidth: true
    }
    return (
        <div className="process-two pt-5 pb-0">
            <div className="container">
                <div className="row">
                    <div className="col-xl-7 col-lg-8">
                        <div className="heading-box">
                            
                            <h2 className="heading-title wow fadeInUp animated animated">
                              Free Consulting <span style={{opacity: '1', transform: "translateX(0px)", transition: "opacity 0.3s", transform: "0.3s;"}}>→</span>
                            </h2>
                        </div>
                    </div>
                </div>
                <Slider className="process-two-slider" {...Processslider}>
                    <div className="process-two-slider-item">
                        <div className="step-no">01</div>
                        <div className="process-two-box-outer">
                            <div className="process-two-box">
                                <div className="process-two-box-icon">
                                    <i className="flaticon-application" />
                                </div>
                                <div className="process-two-box-title">
                                    <h3>SEAMLESS EXECUTION</h3>
                                    <p>
                                    From initial consultation to legal registration, your Will is drafted, and executed remotely - saving you time, money, and stress.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="process-two-slider-item">
                        <div className="step-no">02</div>
                        <div className="process-two-box-outer">
                            <div className="process-two-box">
                                <div className="process-two-box-icon">
                                    <i className="flaticon-contract" />
                                </div>
                                <div className="process-two-box-title">
                                    <h3>EXPERT LEGAL SUPPORT</h3>
                                    <p>
                                    Our legal experts specialize in Indian inheritance law for NRIs. Every step is handled with precision and 100% legality.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="process-two-slider-item">
                        <div className="step-no">03</div>
                        <div className="process-two-box-outer">
                            <div className="process-two-box">
                                <div className="process-two-box-icon">
                                    <i className="flaticon-approval" />
                                </div>
                                <div className="process-two-box-title">
                                    <h3>STRESS-FREE PROCESS</h3>
                                    <p>We provide personalized guidance, and full support - giving you peace of mind and protection for your legacy.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="process-two-slider-item">
                        <div className="step-no">04</div>
                        <div className="process-two-box-outer">
                            <div className="process-two-box">
                                <div className="process-two-box-icon">
                                    <i className="flaticon-money-1" />
                                </div>
                                <div className="process-two-box-title">
                                    <h3>TAILORED GUIDANCE</h3>
                                    <p>
                                    We guide you through every step with full legal compliance and a friendly, tailor-made process.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        </div>

    )
}
export default Processtwo;